/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropCondition.vue?vue&type=template&id=0533c6ce&scoped=true"
import script from "./popAirdropCondition.vue?vue&type=script&lang=js"
export * from "./popAirdropCondition.vue?vue&type=script&lang=js"
import style0 from "./popAirdropCondition.vue?vue&type=style&index=0&id=0533c6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533c6ce",
  null
  
)

export default component.exports